"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWidth = useWidth;
exports.useResponsiveLayout = useResponsiveLayout;
exports.useScrollLockOutsideRef = useScrollLockOutsideRef;
exports.SMALL_DESKTOP_WIDTH = exports.TABLET_WIDTH = exports.MOBILE_WIDTH = void 0;

var _react = require("react");

var _lodash = require("lodash");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function useWidth() {
  var defaultReference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var ref = (0, _react.useRef)(defaultReference);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var setWidthFromRef = (0, _react.useCallback)(function () {
    var newWidth = ref.current ? ref.current.getBoundingClientRect().width : 0;
    setWidth(newWidth);
  }, [ref, setWidth]);
  (0, _react.useEffect)(function () {
    setWidthFromRef();
    window.addEventListener('resize', setWidthFromRef);
    return function () {
      return window.removeEventListener('resize', setWidthFromRef);
    };
  }, [setWidthFromRef]);
  return {
    ref: ref,
    width: width
  };
}

var MOBILE_WIDTH = 640;
exports.MOBILE_WIDTH = MOBILE_WIDTH;
var TABLET_WIDTH = 768;
exports.TABLET_WIDTH = TABLET_WIDTH;
var SMALL_DESKTOP_WIDTH = 1024;
exports.SMALL_DESKTOP_WIDTH = SMALL_DESKTOP_WIDTH;

function useResponsiveLayout() {
  var _useWidth = useWidth(document.body),
      width = _useWidth.width;

  return {
    width: width,
    isMobile: width > 0 && width <= MOBILE_WIDTH,
    isTablet: width > MOBILE_WIDTH && width <= TABLET_WIDTH,
    isMobileOrTablet: width > 0 && width <= TABLET_WIDTH,
    isLowerRes: width > 0 && width <= SMALL_DESKTOP_WIDTH
  };
}
/**
 * Below scroll lock function sourced from
 * https://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily
 * and adapted to a react hook
 */
// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36


var KEYS_TO_LOCK = {
  37: true,
  38: true,
  39: true,
  40: true,
  32: true
};
var supportsPassive = false;

try {
  window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
      return true;
    }
  }));
} catch (e) {}

var WHEEL_OPT = supportsPassive ? {
  passive: false
} : false;
var WHEEL_EVENT = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

function isEventInElement(event, domElement) {
  return domElement && domElement.contains(event.target);
}

var isAtTop = function isAtTop(domEl) {
  return domEl.scrollTop === 0;
};

var isAtBottom = function isAtBottom(domEl) {
  return domEl.scrollTop === domEl.scrollHeight - domEl.offsetHeight;
};

var DOM_ELEMENTS_TO_IGNORE = ['INPUT', 'SELECT'];

function shouldPreventScroll(event, domElement) {
  return !isEventInElement(event, domElement) || // If the event target is outside the whitelisted dom element
  isAtTop(domElement) && event.deltaY < 0 || // If the dom element is scrolled to the top and we're scrolling more
  isAtBottom(domElement) && event.deltaY > 0 // If the dom element is scrolled to the bottom and we're scrolling more
  ;
}

function useScrollLockOutsideRef() {
  var ref = (0, _react.useRef)();
  var preventDefault = (0, _react.useCallback)(function (e) {
    if (shouldPreventScroll(e, ref.current)) {
      e.preventDefault();
    }
  }, []);
  var preventDefaultForScrollKeys = (0, _react.useCallback)(function (e) {
    var tagName = e.target.tagName;

    if (shouldPreventScroll(e, ref.current) && KEYS_TO_LOCK[e.keyCode] && !(0, _lodash.includes)(DOM_ELEMENTS_TO_IGNORE, tagName)) {
      e.preventDefault();
      return false;
    }
  }, []);
  var disableScroll = (0, _react.useCallback)(function () {
    document.body.addEventListener('DOMMouseScroll', preventDefault, false); // older FF

    document.body.addEventListener(WHEEL_EVENT, preventDefault, WHEEL_OPT); // modern desktop

    document.body.addEventListener('touchmove', preventDefault, WHEEL_OPT); // mobile

    document.body.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }, [preventDefault, preventDefaultForScrollKeys]);
  var enableScroll = (0, _react.useCallback)(function () {
    document.body.removeEventListener('DOMMouseScroll', preventDefault, false);
    document.body.removeEventListener(WHEEL_EVENT, preventDefault, WHEEL_OPT);
    document.body.removeEventListener('touchmove', preventDefault, WHEEL_OPT);
    document.body.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  }, [preventDefault, preventDefaultForScrollKeys]);
  (0, _react.useEffect)(function () {
    disableScroll();
    return function () {
      return enableScroll();
    };
  }, [disableScroll, enableScroll]);
  return ref;
}